import { render, staticRenderFns } from "./GestionePermessi.vue?vue&type=template&id=0ff250b4&"
import script from "./GestionePermessi.vue?vue&type=script&lang=js&"
export * from "./GestionePermessi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports